import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Modal } from 'antd';
import event from '~helpers/mixpanel';
import CounterOffer from '~components/counter-offer';
import CounterOfferNotice from '../notice';

import { TagType } from '~constants/tagType';
import { pageType } from '~constants/pages';
import { decodeBase64 } from 'common/helpers/decodeBase64';

const ACCEPT = 'accept';
const REJECT = 'reject';

export default class CounterOfferEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedRadio: '',
      visible: false,
    };
  }

  componentDidMount() {
    if (this.props.isAutoOpen) {
      this.setState({ visible: true });
    }
  }

  handleCheckRadio = e => {
    if (e?.target?.value === ACCEPT) {
      event('Clicked Edit Counter Offer', {
        'Clicked Position': 'Accept Original Booking',
        'Current Page Type': this.props.from,
      });
    }
    if (e?.target?.value === REJECT) {
      event('Clicked Edit Counter Offer', {
        'Clicked Position': 'Reject Counter Offer',
        'Current Page Type': this.props.from,
      });
    }
    const checkValue = e?.target?.value;
    this.setState({
      checkedRadio: checkValue,
    });
  };

  handleConfirm = () => {
    const { checkedRadio } = this.state;
    const { confirmOrder, rejectOrder, id } = this.props;

    if (!checkedRadio) {
      this.setState({ visible: false });
      return;
    } else if (checkedRadio === ACCEPT) {
      event('Confirmed Edit Offer', {
        'Booking Status': 'Accept Original Booking',
        'Current Page Type': this.props.from,
      });
      confirmOrder();
    } else if (checkedRadio === REJECT) {
      event('Confirmed Edit Offer', {
        'Booking Status': 'Reject Counter Offer',
        'Current Page Type': this.props.from,
      });
      rejectOrder({
        variables: {
          input: {
            id,
            rejectedReason: 'Reject Counter Offer',
          },
        },
      });
    }

    this.setState({ visible: false });
  };

  handleOpenEditModal = () => {
    if (this.props?.history?.location?.pathname === '/board') {
      const { property, referenceId, stage, bookingJourney } = this.props?.record || {};
      const { name, slug } = property || {};
      const decodedId = decodeBase64(this.props?.id)?.id;

      event('Clicked Pending Information Btn', {
        'Clicked Position': 'Edit',
        'Property Name': name,
        'Property ID': decodedId,
        'Property Slug': slug,
        'Booking Stage': stage?.toLowerCase(),
        'Booking Journey': bookingJourney?.toLowerCase(),
        'Booking ID': referenceId,
        'Current Page Type': pageType.dashboard,
      });

      event('Viewed Edit Counter Offer', {
        'Auth Method': 'Dashboard Shortcut',
        'Current Page Type': pageType.dashboard,
      });
    }
    if (this.props?.history?.location?.pathname?.includes('/detail')) {
      this.props?.handleClickActionBtnTrack?.('Edit');
      if (!this.props?.isAutoOpen) {
        event('Viewed Edit Counter Offer', {
          'Auth Method': 'Booking Details Page',
          'Current Page Type': pageType.bookingDetailPage,
        });
      }
    }
    if (this.props?.history?.location.pathname === '/booking/list') {
      event('Clicked Action Btn in Booking List Page', {
        'Clicked Position': 'Edit',
        'Current Page Type': pageType.bookingList,
      });
      event('Viewed Edit Counter Offer', {
        'Auth Method': 'Booking List Shortcut',
        'Current Page Type': pageType.bookingList,
      });
    }
    this.setState({ visible: !this.state.visible, checkedRadio: '' });
  };
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.visible) {
      if (this.props.isAutoOpen) {
        event('Viewed Edit Counter Offer', {
          'Auth Method': 'Livechat Page',
          'Current Page Type': this.props.from,
        });
      }
    }
    return true;
  }
  cancelModal = () => {
    this.setState({ visible: !this.state.visible, checkedRadio: '' });
  };

  render() {
    const { t, record, confirmLoading, rejectLoading } = this.props;
    const { visible, checkedRadio } = this.state;

    return (
      <div className="edit-modal">
        <button className="edit-modal__btn" onClick={this.handleOpenEditModal}>
          {t('edit')}
        </button>
        <Modal
          title={
            <CounterOfferNotice
              title={t('landlord.booking.counter_offer.edit_modal.title')}
              from="Edit Offer Page"
            />
          }
          width={812}
          visible={visible}
          okText={t('confirm')}
          okButtonProps={{
            loading: confirmLoading || rejectLoading,
            disabled: confirmLoading || rejectLoading,
          }}
          onOk={this.handleConfirm}
          onCancel={this.cancelModal}
          wrapClassName="counter-offer-wrapper"
        >
          <span className="edit-modal__content-subtitle">
            {t('landlord.booking.counter_offer.edit_modal.desc')}
          </span>
          <CounterOffer
            property={{
              ...record?.counterOffers?.[0],
              propertyName: record?.counterOffers?.[0]?.property?.name,
            }}
            t={t}
            showTotalPrice
            tagType={TagType.counterOffer}
            descType={checkedRadio}
          />
          <CounterOffer
            property={record}
            t={t}
            showTotalPrice
            tagType={TagType.origin}
            descType={checkedRadio}
          />
          <div className="edit-modal__change-booking">
            <span className="edit-modal__change-booking__title">
              {t('landlord.booking.counter_offer.edit_modal.change_booking.title')}
            </span>
            <div className="edit-modal__change-booking__radio-group">
              <Radio.Group onChange={this.handleCheckRadio} value={checkedRadio}>
                <Radio value={ACCEPT}>
                  <div className="edit-modal__change-booking__radio-group-content">
                    <span className="edit-modal__change-booking__radio-group-content__title">
                      {t('landlord.booking.counter_offer.edit_modal.change_booking.accept.title')}
                    </span>
                    <span className="edit-modal__change-booking__radio-group-content__subtitle">
                      {t(
                        'landlord.booking.counter_offer.edit_modal.change_booking.accept.subtitle',
                      )}
                    </span>
                  </div>
                </Radio>
                <Radio value={REJECT}>
                  <div className="edit-modal__change-booking__radio-group-content">
                    <span className="edit-modal__change-booking__radio-group-content__title">
                      {t('landlord.booking.counter_offer.edit_modal.change_booking.reject.title')}
                    </span>
                    <span className="edit-modal__change-booking__radio-group-content__subtitle">
                      {t(
                        'landlord.booking.counter_offer.edit_modal.change_booking.reject.subtitle',
                      )}
                    </span>
                  </div>
                </Radio>
              </Radio.Group>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

CounterOfferEditModal.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  handleClickActionBtnTrack: PropTypes.func,
  from: PropTypes.string,
};

CounterOfferEditModal.defaultProps = {};
